<section>
    <div class="row">
        <!-- Ticket Status Donut Chart Starts -->
        <div class="col-md-4 col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{'AllTickets' | translate}}</h4>
                </div>
                <div class="card-body">
                    <canvas id="allTickets" baseChart class="horizontal-bar-chart-ex chartjs" height="300"></canvas>
                </div>
            </div>
        </div>
        <!-- Ticket Status Donut Chart Starts -->
        <div class="col-md-4 col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{'ActiveTickets' | translate}}</h4>
                </div>
                <div class="card-body">
                    <canvas id="activeTickets" baseChart class="horizontal-bar-chart-ex chartjs" height="300"></canvas>
                </div>
            </div>
        </div>
        <!-- Ticket Status Donut Chart Starts -->
        <div class="col-md-4 col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{'ClosedTickets' | translate}}</h4>
                </div>
                <div class="card-body">
                    <canvas id="closedTickets" baseChart class="horizontal-bar-chart-ex chartjs" height="300"></canvas>
                </div>
            </div>
        </div>
        <!-- Ticket Status Donut Chart Starts -->
        <div class="col-md-6 col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{'Status' | translate}}</h4>
                </div>
                <div class="card-body">
                    <canvas id="ticketStatus" class="doughnut-chart-ex chartjs" baseChart height="300"></canvas>
                </div>
            </div>
        </div>
        <!-- Ticket Priority Donut Chart Starts -->
        <div class="col-md-6 col-12">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{'Priority' | translate}}</h4>
                </div>
                <div class="card-body">
                    <canvas id="ticketPriority" class="doughnut-chart-ex chartjs" baseChart height="300"></canvas>
                </div>
            </div>
        </div>
        <!-- Ticket Priority Donut Chart Starts -->
        <!-- <div class="col-md-4 col-12" *ngIf="token === 'dashboardToken'">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{'Project' | translate}}</h4>
                </div>
                <div class="card-body">
                    <canvas id="projectStatus" class="doughnut-chart-ex chartjs" baseChart height="300"></canvas>
                </div>
            </div>
        </div> -->
        <div class="col-md-4 col-12" *ngFor="let item of ongoingProjects">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">
                        <ng-container *ngIf="token === 'dashboardToken'">{{item.customerName}} - </ng-container>{{item.projectName}}
                    </h4>
                </div>
                <div class="card-body">
                    <canvas id="ongoingProjects{{item.startProjectId}}" baseChart
                        class="horizontal-bar-chart-ex chartjs" height="300"></canvas>
                </div>
            </div>
        </div>
    </div>
</section>
<app-alert [result]="result"></app-alert>